import { useQuery } from '@tanstack/react-query';

import MerchandisingCollectionsService from '@/services/MerchandisingCollectionsService';

export const MERCHANDISING_COLLECTION_SLICE_QUERY_KEY = [
  'merchandisingCollectionSlice',
];

export function useGetMerchandisingCollectionSlice(
  collectionId: number,
  sliceId: number,
) {
  const { data, isFetching, isError } = useQuery({
    queryKey: [
      ...MERCHANDISING_COLLECTION_SLICE_QUERY_KEY,
      collectionId,
      sliceId,
    ],
    enabled: !!collectionId && !!sliceId,
    queryFn: () =>
      MerchandisingCollectionsService.findSlice(collectionId, sliceId),
  });

  return {
    merchandisingCollectionSlice: data,
    isLoading: isFetching,
    isError,
  };
}
